import {ErrorHandler, Provider} from "@angular/core";
import {GlobalErrorHandlerService} from "../services/global-error-handler.service";

export const GlobalErrorHandlerProvider: Provider = [
  {
    provide: ErrorHandler,
    useClass: GlobalErrorHandlerService
  }
]
